import { render } from "./AppHowManyPercent.vue?vue&type=template&id=a7c4410c"
import script from "./AppHowManyPercent.vue?vue&type=script&lang=js"
export * from "./AppHowManyPercent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__